import BaseFilterModel from "./BaseFilterModel";
import { computed, observable, action } from "mobx";
import isFunction from "lodash/isFunction";
import reduce from "lodash/reduce";
import toLower from "lodash/toLower";
import isEmpty from "lodash/isEmpty";
import FormModel from "../../FormModel";

class SearchFilterModel extends BaseFilterModel {
    @observable searchForm;

    constructor(definition) {
        super(definition);
        this.searchForm = definition.searchForm ?? new FormModel({});
    }

    get key() {
        return this.definition.name || "search";
    }

    @computed
    get func() {
        return rowData => {
            if (isFunction(this.definition.searchFunction)) {
                return this.definition.searchFunction(rowData, toLower(this.value));
            } else {
                const lowerCaseSearchValue = toLower(this.value);
                if (isEmpty(lowerCaseSearchValue)) {
                    return true;
                }
                return reduce(this.definition.searchableColumns, (result, columnName) => {
                    return result || (rowData.get(columnName)
                        && toLower(rowData.get(columnName).toString()).includes(lowerCaseSearchValue));
                }, false);
            }
        };
    }

    @computed
    get searchValue() {
        return this.searchForm.get("searchValue");
    }

    get defaultValue() {
        return super.defaultValue || "";
    }

    @action
    updateValue(newValue) {
        this.searchForm.set("searchValue", newValue);
        this.value = this.searchForm.get("searchValue");
    }
}

export default SearchFilterModel;
